import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import PhoneNumberItem from "../../../../Components/Common/PhoneNumberItem/PhoneNumberItem";
import EmailAddressItem from "../../../../Components/Common/EmailAddressItem/EmailAddressItem";
import MapDetails from "../tabOverview/mapDetails";
import "./siteLocations.Styles.css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteSingleCustomerSiteLocation,
  deleteSingleCustomerSiteLocationSuccess,
  getSingleCustomerSiteLocationListData,
} from "../../../../store/customers/action";
import { isEmpty } from "lodash";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import { toast } from "react-toastify";
import { SendEmail } from "../../../../Components/Common/SendEmail";

/**
 * One card per site location (Task 24760).
 *
 * Two bare icons stacked in the corner became the house "..." row menu, so
 * this reads like every other list in the app and there is room to add
 * actions without stacking a third icon.
 *
 * A REAL BUG FIXED HERE: after deleting, the list was reloaded with
 * `customer_data: { Customer_Id }`, but the endpoint filters on
 * `customer_data.Id`. The filter therefore never applied and the refresh came
 * back with EVERY site location for EVERY customer - so deleting one site
 * appeared to fill the tab with strangers' addresses. It now sends `Id`,
 * matching the load and the create/update paths.
 */
export default function SiteLocationCard({
  searchResult,
  handleSiteSingleLocationGetData,
  setIsEditSiteLocation,
  setModalSiteLocation,
  fromCustomerPage,
  Customer_Id,
  page,
}) {
  const dispatch = useDispatch();

  const [showMap, setShowMap] = useState([]);
  const [siteLocationSelectedForDelete, setSiteLocationSelectedForDelete] =
    useState(null);
  const [modalSiteLocationDelete, setModalSiteLocationDelete] = useState(false);

  const { deleteSingleCustomerSiteLocationResponseAPI } = useSelector(
    (state) => ({
      deleteSingleCustomerSiteLocationResponseAPI:
        state.Customers.deleteSingleCustomerSiteLocationResponse,
    })
  );

  useEffect(() => {
    if (isEmpty(deleteSingleCustomerSiteLocationResponseAPI)) return;
    if (deleteSingleCustomerSiteLocationResponseAPI.status === 200) {
      toast.success(deleteSingleCustomerSiteLocationResponseAPI.message);
      if (fromCustomerPage) {
        dispatch(
          getSingleCustomerSiteLocationListData([
            {
              customer_data: {
                // `Id` is the key the endpoint filters on - see the note at
                // the top of this file.
                Id: Customer_Id,
              },
            },
          ])
        );
      }
      setModalSiteLocationDelete(false);
    } else {
      // Was reporting off the action CREATOR rather than the response, so an
      // actual failure showed "undefined".
      toast.error(
        deleteSingleCustomerSiteLocationResponseAPI?.message ||
          "Could not delete that site location"
      );
    }
    dispatch(deleteSingleCustomerSiteLocationSuccess([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteSingleCustomerSiteLocationResponseAPI]);

  const [modalSendEmail, setModalSendEmail] = useState(false);
  const toggleSendEmail = () => setModalSendEmail(!modalSendEmail);
  const [sendEmailTo, setSendEmailTo] = useState("");

  const isMapOpen = (id) => showMap.some((item) => item === id);
  const toggleMap = (id) =>
    setShowMap((prev) =>
      prev.some((item) => item === id)
        ? prev.filter((item) => item !== id)
        : [...prev, id]
    );

  return (
    <>
      {modalSendEmail && (
        <SendEmail
          modal={modalSendEmail}
          setModal={setModalSendEmail}
          toggle={toggleSendEmail}
          externalEMailTo={sendEmailTo}
        />
      )}

      <DeleteModal
        modal={modalSiteLocationDelete}
        setModal={setModalSiteLocationDelete}
        show={modalSiteLocationDelete}
        onDeleteClick={() => {
          dispatch(
            deleteSingleCustomerSiteLocation([siteLocationSelectedForDelete])
          );
        }}
        onCloseClick={() => {
          setModalSiteLocationDelete(false);
        }}
      />

      <div className={"site-location-wraping-container"}>
        {searchResult?.map((location) => (
          <div
            key={location?.Id}
            className={"sitelocations-main-card-frame"}
          >
            <div className={"header-and-edit-button-container"}>
              <div className="min-w-0">
                <h5 className="text-truncate">
                  {location?.BusinessName || "Unnamed site"}
                </h5>
                <span className="text-muted fs-13">#{location?.Id}</span>
                {location?.SiteReference && (
                  <span className="badge bg-soft-secondary text-secondary ms-1">
                    {location.SiteReference}
                  </span>
                )}
              </div>

              <UncontrolledDropdown>
                <DropdownToggle
                  tag="button"
                  type="button"
                  className="btn btn-sm btn-link text-muted p-0"
                >
                  <i className="ri-more-fill fs-16"></i>
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem
                    onClick={() => {
                      handleSiteSingleLocationGetData(location?.Id);
                      setModalSiteLocation(true);
                      setIsEditSiteLocation(true);
                    }}
                  >
                    <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
                    Edit
                  </DropdownItem>
                  <DropdownItem onClick={() => toggleMap(location?.Id)}>
                    <i className="ri-map-pin-line align-bottom me-2 text-muted"></i>
                    {isMapOpen(location?.Id) ? "Hide map" : "Show map"}
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem
                    className="text-danger"
                    onClick={() => {
                      setSiteLocationSelectedForDelete(location?.Id);
                      setModalSiteLocationDelete(true);
                    }}
                  >
                    <i className="ri-delete-bin-fill align-bottom me-2 text-danger"></i>
                    Delete
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>

            <div className="site-location-address">
              <h6>Address</h6>
              <div>{location?.AddressLine1}</div>
              {location?.AddressLine2 && <div>{location.AddressLine2}</div>}
              {location?.AddressLine3 && <div>{location.AddressLine3}</div>}
              {location?.AddressLine4 && <div>{location.AddressLine4}</div>}
              {location?.AddressPostCode && (
                <div className="fw-medium">{location.AddressPostCode}</div>
              )}
            </div>

            {(!isEmpty(location?.contactemailaddress_list) ||
              !isEmpty(location?.contacttelephonenumber_list)) && <hr />}

            <div
              className={"mt-1 emailAddress"}
              style={{ overflow: "visible" }}
            >
              {!isEmpty(location?.contactemailaddress_list) &&
                location?.contactemailaddress_list?.map((email, index) => (
                  <div key={index} className={"d-flex align-items-center"}>
                    <i className="fa-regular fa-envelope pe-1"></i>
                    <EmailAddressItem
                      ownerId={location?.Id ?? "site-location"}
                      idx={index}
                      email={email?.EmailAddress}
                      isDefault={email?.FlagDefault === "1"}
                      onCompose={(address) => {
                        setSendEmailTo(address);
                        setModalSendEmail(true);
                      }}
                    />
                  </div>
                ))}
            </div>

            <div className={"mt-1 phoneNumber"} style={{ overflow: "visible" }}>
              {!isEmpty(location?.contacttelephonenumber_list) &&
                location?.contacttelephonenumber_list?.map((phone, index) => (
                  <div key={index} className={"d-flex align-items-center"}>
                    <i className="fa-solid fa-phone pe-1"></i>
                    <PhoneNumberItem
                      ownerId={location?.Id ?? "site-location"}
                      idx={index}
                      number={phone?.TelephoneNumber}
                      isDefault={phone?.FlagDefault === "1"}
                    />
                  </div>
                ))}
            </div>

            {isMapOpen(location?.Id) && (
              <div className="mt-2">
                {location?.AddressPostCode ? (
                  <MapDetails
                    singleCustomerPostcode={location?.AddressPostCode}
                  />
                ) : (
                  // The old Show Map button opened nothing at all without a
                  // postcode, which looks like the map failing to load.
                  <div className="text-muted fs-13">
                    No postcode on this site, so there is nothing to map.
                  </div>
                )}
                <Button
                  size="sm"
                  className="btn btn-soft-secondary mt-2"
                  onClick={() => toggleMap(location?.Id)}
                >
                  Hide map
                </Button>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
